import getMlsThreshold from '../../../../utils/get-mls-threshold';

/**
 * Get a sentence describing the MLS that has been applied.
 *
 * @param {object} customer - Object of customer.
 * @param {string} customer.scale - Customer scale.
 * @param {number} customer.income - Customer income.
 */
// @ts-expect-error - Automatic, Please fix when editing this file
const getPrefixSentence = ({ income, scale }) => {
  const threshold = getMlsThreshold({ income, scale });
  if ((threshold?.rate ?? 0) <= 0) {
    return null;
  }
  return `${threshold.rate}% MLS applying to`;
};

export default getPrefixSentence;
